import { Delivery } from "../../../types/delivery/delivery";
import { DeliveryState } from "../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    selectedDelivery: Delivery;
  };
}

export const setSelectedDeliveryDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { selectedDelivery } = action.payload;
  state.selectedDelivery = selectedDelivery;
};
